<template>
  <div class="home">
    123
  </div>
</template>

<script>
export default {
  name: 'Home',
  data() {
    return {
      // hall: {
      //   id: null,
      //   hallCount: 0,
      // }
    }
  },
  methods: {
    // queryHallOne(id) {
    //   var that = this
    //   var params = { id: id }
    //   this.$queryOne(
    //     'HallInfo',
    //     params,
    //     ['hallCount'],
    //     function(res) {
    //       that.$fill(that.hall, res['data'])
    //     }
    //   )
    // },
  },
  mounted() {
    console.log(this.$getVisited('12'))
  },
  created() {
  },
}
</script>

<style>
</style>
